export default "__VITE_ASSET__DeOCamyG__"